import { Layout as OpenerLayout, Opener as OpenerUI } from '@portals/core/src/components/Opener/Opener';
import { trackOpener } from '@portals/tracking/src/content/trackOpener';
import { TrackingContext } from '@portals/tracking/src/context/tracking';
import React, { useCallback } from 'react';

import { ContentOpener as OpenerModel } from '../../../models';

export interface Props {
  node: OpenerModel;
  children: React.ReactNode;
}

export const Opener: React.FC<Props> = ({ node, children }: Props) => {
  const handleTracking = useCallback(
    (payload) => {
      trackOpener({
        id: node.id,
        layout: node.layout,
        headline: node.headline?.text,
        ...payload,
      });
    },
    [node?.headline?.text, node?.id, node?.layout]
  );
  let layout: OpenerLayout = node.layout;
  if (node.layout === 'productPage' && node.actions?.length === 0) {
    layout = 'productPageSmall';
  }
  return (
    <TrackingContext.Provider value={{ trackLink: handleTracking }}>
      <OpenerUI layout={layout}>{children}</OpenerUI>
    </TrackingContext.Provider>
  );
};
